export module Utils {
	export class Options {
		protected options: {};

		constructor(options) {
			this.options = (typeof options == 'object') ? options : {} as any;
		}

		get(variable, fallback = null) {
			return this.has(variable) ? this.options[variable] : fallback;
		};

		has(variable){
			return this.options.hasOwnProperty(variable);
		}
	}

	/** Callback queue used to perform function calls in garanted order */
	export class CbQueue {
		public list = [];

		/** Add new callbac to queue */
		add(cb) {
			this.list.push(cb);
		};

		/** Performs next available queue callback */
		next() {
			if (this.list.length)
				this.list.shift()();
		};
	}

	export function hash(str) {
		if (Array.isArray(str))
			str = str.join('_');
		return str;
		/*
			var hash = 0, i, chr, len;
			if (str.length === 0) return hash;
			for (i = 0, len = str.length; i < len; i++) {
				chr   = str.charCodeAt(i);
				hash  = ((hash << 5) - hash) + chr;
				hash |= 0; // Convert to 32bit integer
			}
			return hash;
		*/
	}

	export function cubicTexture(str, floor, ceiling) {
		if (floor == undefined)
			floor = str;
		if (ceiling == undefined)
			ceiling = str;
		/** [+X, -X, +Y, -Y, +Z, -Z] */
		return [str, str, str, str, ceiling, floor];
	}

	export function replaceAll(str, pairs) {
		let re = new RegExp(Object.keys(pairs).join("|"), "gi");
		return str.replace(re, function (m) {
			return pairs[m];
		});
	}

	export class Range{
		public min: number;
		constructor(
			min:any = -Infinity,
			public max:number = Infinity){
			if (min instanceof Object){
				this.min = min.hasOwnProperty('min') ? Number(min.min) : -Infinity;
				this.max = min.hasOwnProperty('max') ? Number(min.max) : Infinity;
			}
			else {
				this.min = (min === null)
					? -Infinity
					: Number(min);
				if (this.max === null)
					this.max = Infinity;
			}
			if (this.min > this.max)
				this.min = [this.max, this.max = this.min][0];	// swap
		}

		/**
		 * Returns correts number to be within range
		 * @param {number} value
		 */
		limit(value:number):number{
			if (value < this.min) return this.min;
			if (value > this.max) return this.max;
			return value;
		}

		fit(value:number):boolean{
			return !((value < this.min) || (value > this.max));
		}
	}

	export class Transform{
		public scale: number = 1.0;
		public rotate: number[] = [0,0,0];
		public offset: number[] = [0,0,0];

		constructor(data:any = null){
			if (data && (data instanceof Object)){
				if (data.hasOwnProperty('scale'))
					this.scale = Number(data.scale);
				if (data.hasOwnProperty('rotate') && data.rotate)
					this.rotate = Utils.Transform.numVector(data.rotate);
				if (data.hasOwnProperty('offset') && data.offset)
					this.offset = Utils.Transform.numVector(data.offset);
			}
		}

		protected static numVector(data:any):number[]{
			if (Array.isArray(data))
				return [
					Number(data[0]),
					Number(data[1]),
					Number(data[2])
				];
			let ret = [0,0,0];
			if (data.hasOwnProperty('x'))
				ret[0] = data.x;
			if (data.hasOwnProperty('y'))
				ret[1] = data.y;
			if (data.hasOwnProperty('z'))
				ret[2] = data.z;
			return ret;
		}
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/Utils.ts